import { useEffect } from 'react'
import { getCarteVitaleInfos, resetCarteVitaleInfos, selectCarteVitaleInfos, selectPatientGetRequestTracker } from '@/redux/reducers/patient.reducer'
import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'

export function usePlatformVitaleCardDialog({ open }: { open: boolean }) {
  const dispatch = useAppDispatch()

  const carteVitaleInfos = useAppSelector(selectCarteVitaleInfos)
  const carteVitaleInfosGetRequestTracker = useAppSelector(selectPatientGetRequestTracker)

  useEffect(() => {
    if (open) {
      dispatch(getCarteVitaleInfos())
    } else {
      dispatch(resetCarteVitaleInfos())
    }
  }, [dispatch, open])

  return {
    error: !!carteVitaleInfosGetRequestTracker.error,
    infos: carteVitaleInfos,
    loading: carteVitaleInfosGetRequestTracker.loading,
  }
}
